import Clickable from '@/components/Clickable';
import PropTypes from 'prop-types';
import Typography from '@/components/Typography';
import { useWizard } from 'react-use-wizard';

const PackSizeStep = ({ packSizeOptions, updatePackConfig, packConfig }) => {
	const { nextStep } = useWizard();

	const handleSelectPackSize = (option) => {
		updatePackConfig('packSize', option);
	};

	const handleContinue = () => {
		if (packConfig.packSize) {
			nextStep();
		}
	};

	return (
		<div className="flex flex-col items-center px-4 py-6">
			<Typography variant="subhead-lg" component="h1" className="text-centerfont-bold mb-2">
				Build a Pack and Save!
			</Typography>
			<Typography variant="h2" component="h2" className="text-center text-2xl mb-6">
				Choose your pack size
			</Typography>

			<div className="w-full max-w-md flex flex-col gap-4 mb-8">
				{packSizeOptions.map((option) => {
					const isSelected =
						packConfig.packSize && packConfig.packSize.quantity === option.quantity;
					return (
						<button
							key={option.title}
							className={`w-full p-6 flex flex-col items-center justify-center bg-v2-cream rounded-lg border-2 transition-colors ${
								isSelected
									? 'border-red-600 bg-v2-cream-dark'
									: 'border-v2-brown-darker hover:bg-v2-cream-dark'
							}`}
							onClick={() => handleSelectPackSize(option)}>
							<div className="mb-2">
								<div className="relative w-24 h-24">
									<svg viewBox="0 0 100 100" className="w-full h-full">
										<g stroke="#000" strokeWidth="2" fill="none">
											<polygon
												points="81.5,20 97,6 97,65 81.5,78.95"
												fill={isSelected ? '#e74c3c' : '#fff'}
												stroke="#000"
												strokeWidth="2"
											/>

											<polygon
												points="21,18.9 80,19 96,5 35,5"
												fill={isSelected ? '#e74c3c' : '#fff'}
												stroke="#000"
												strokeWidth="2"
											/>

											<rect
												x="20"
												y="20"
												width="60"
												height="60"
												fill={isSelected ? '#e74c3c' : '#fff'}
												stroke="#000"
												strokeWidth="2"
											/>

											<text
												x="40"
												y="60"
												fontSize="30"
												fill={isSelected ? '#fff' : '#e74c3c'}
												stroke="none">
												{option.quantity}
											</text>
										</g>
									</svg>
								</div>
							</div>
							<Typography variant="h3" component="h3" className="text-2xl font-bold mb-1">
								{option.quantity} Pack
							</Typography>
							<Typography
								variant="body"
								component="p"
								className="text-xl text-red-600 font-semibold">
								Save {Math.round(option.discount * 100)}%
							</Typography>
						</button>
					);
				})}
			</div>

			<div className="sticky bottom-0 w-full bg-v2-off-white p-2 text-center">
				<Clickable
					variant="filled"
					disabled={!packConfig.packSize}
					className="px-4 py-2 font-semibold border-2 border-primary hover:border-primary-dark w-full md:w-auto rounded-md"
					onClick={handleContinue}>
					Continue to Cuts
				</Clickable>
			</div>
		</div>
	);
};

export default PackSizeStep;

PackSizeStep.propTypes = {
	packConfig: PropTypes.object.isRequired,
	packSizeOptions: PropTypes.array.isRequired,
	updatePackConfig: PropTypes.func.isRequired,
};
